import { dataCameraAdd } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCameraAdd = /*#__PURE__*/createIcon(dataCameraAdd)
export default IconCameraAdd
